import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductFeatureCoverageComponent } from './product-feature-coverage/product-feature-coverage.component';
import { ProductFeatureGroupCoverageComponent } from './product-feature-group-coverage/product-feature-group-coverage.component';
import { ProductFeatureInvestmentComponent } from './product-feature-investment/product-feature-investment.component';
import { ProductFeatureMultipleCoveragesComponent } from './product-feature-multiple-coverages/product-feature-multiple-coverages.component';
import { ProductFeatureComponent } from './product-feature/product-feature.component';

const DECLARATIONS = [
  ProductCardComponent,
  ProductFeatureComponent,
  ProductFeatureCoverageComponent,
  ProductFeatureInvestmentComponent,
  ProductFeatureMultipleCoveragesComponent,
  ProductFeatureGroupCoverageComponent
];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule]
})
export class ProductSelectComponentsModule {}
